import { Box } from 'edenred-ui';
import styled from 'styled-components';

export const BenefitListContainer = styled(Box)`
  margin-top: 24px;
  min-height: 273px;
  margin-bottom: 32px;
`;

export const BenefitListHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 2px solid ${props => props.theme.altGray2};
  font-weight: ${props => props.theme.fontSemiBold};
  color: ${props => props.theme.gray85};
`;

export const BenefitRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid ${props => props.theme.altGray2};
`;

export const BenefitInfo = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const LimitColumn = styled(Box)`
  width: 200px;
  text-align: left;
`;

export const BenefitLimit = styled(Box)`
  font-size: ${props => props.theme.sizeMedium};
  text-align: left;
`;

export const FrequencyLabel = styled.span`
  font-size: ${props => props.theme.sizeExtraSmall};
  margin-left: 4px;
`;
